import { Header } from '@components/layout/Header/Header';
import { Footer } from '@components/layout/Footer/Footer';
import { ReactNode } from 'react';
import { NavbarTheme } from 'src/types/header-types';
import { useRevalidateOnRefocus } from '@hooks/useSwrApi';


// Interface
// ******************************************
interface LayoutDefaultProps {
  children?: ReactNode,
  navbarTheme?: NavbarTheme,
  hideFooter?: boolean,
}

/**
 * @description Default layout. It renders the header and the footer.
 * - children - The children to render inside the layout.
 * - navbarTheme - The theme of the navbar, 'default' | 'transparent'.
 *
 * @example
 * // if you want a transparent header, pass the navbarTheme prop
 * MyPage.getLayout = function getLayout(page: ReactNode) {
 *   return (
 *     <LayoutDefault navbarTheme="transparent">
 *       {page}
 *     </LayoutDefault>
 *   );
 * };
 */
export const LayoutDefault = function LayoutFunction(props: LayoutDefaultProps) {
  // Destructure props
  const {
    children,
    navbarTheme,
    hideFooter,
  } = props;

  // Check if we should revalidate SWR cache on tab refocus
  useRevalidateOnRefocus();


  return (
    <>
      {/* Place all the sticky top banners in Header component */}
      <Header navbarTheme={navbarTheme} />
      {children}
      <Footer hideFooter={hideFooter} />
    </>
  );
};
